var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.69 8.189C13.246 8.608 12.826 9.004 12.668 9.433L12.547 9.76L12.157 9.794H11.807L11.646 9.433C11.488 9.004 11.069 8.608 10.625 8.189C10.36 7.939 10.093 7.686 9.86104 7.414C9.46904 7.048 9.33304 6.433 9.55004 5.884C9.76904 5.335 10.293 4.98 10.886 4.98H13.429C14.022 4.98 14.546 5.335 14.764 5.884C14.982 6.432 14.846 7.048 14.417 7.453C14.222 7.686 13.955 7.939 13.69 8.189ZM14.491 12.692C14.009 12.193 14.009 11.805 14.478 11.32C16.528 9.353 17.882 8.053 18.026 6.549C18.115 5.434 17.811 4.413 17.17 3.677C16.554 2.969 15.669 2.563 14.583 2.5L9.70404 2.501C8.64704 2.563 7.76304 2.97 7.14704 3.677C6.50604 4.414 6.20204 5.434 6.29004 6.549C6.29104 6.552 6.29104 6.555 6.29104 6.558C6.43504 8.055 7.78904 9.354 9.82604 11.307C10.308 11.805 10.308 12.194 9.83904 12.679C7.78904 14.646 6.43504 15.945 6.29004 17.45C6.20204 18.566 6.50604 19.585 7.14704 20.322C7.76304 21.029 8.64704 21.437 9.73304 21.5L14.612 21.499C15.669 21.437 16.554 21.03 17.17 20.322C17.811 19.586 18.115 18.566 18.025 17.442C17.882 15.946 16.527 14.647 14.491 12.692Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/Hourglass.acbb19a7.svg";
export { ForwardRef as ReactComponent };